import { useContext, useEffect } from "react";
import { LoggedInUserContext } from "../context/loggedInUserContext";
import { getItem } from "../utils/localStorage";
import Login from "../pages/auth/Login";
import MapSVG from "../components/MapSVG";
import { useNavigate } from "react-router-dom";
import { Roles } from "../types/role.enums";
import AuctionHeaderForm from "../components/AuctionHeaderForm";
const HomePage = () => {
  const user = getItem("user");
  const navigate = useNavigate();
  const { loggedInUserContext, setLoggedInUserContext } =
    useContext(LoggedInUserContext);
  useEffect(() => {
    if (
      loggedInUserContext?.role.name === Roles.SUPER_ADMIN &&
      loggedInUserContext &&
      user
    )
      navigate("/admin");
  }, []);
  useEffect(() => {
    setLoggedInUserContext(user);
  }, []);
  return (
    <>
      <div className="flex mt-5 flex-wrap">
        <div className="w-9/12">
          <h1 className="text-center">Find Auctions in your area</h1>
          <AuctionHeaderForm />
          <h1 className="m-2 mt-4 text-xl text-bold">
            Upcoming Auctions by category
          </h1>
          <div className="m-2 flex gap-3 mt-4">
            <ul>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
            </ul>
            <ul>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
            </ul>
            <ul>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
              <li>Automobile Auctions</li>
            </ul>
          </div>
          <h1 className="m-2 text-xl text-bold">Upcoming Auctions by region</h1>
          <MapSVG />
        </div>
        <div className="w-3/12">{!loggedInUserContext && <Login />}</div>
      </div>
    </>
  );
};

export default HomePage;
